import axios from 'src/store/vue-axios/axios.js'

const MAX_RETRIES = 5

const vaultProxyAxiosConfig = {
  baseURL: import.meta.env.VITE_2FAL,
  withCredentials: false,
  transformRequest: (data, headers) => {
    delete headers['Released-At']
    delete headers['frontend-version']
    delete headers.Authorization
    delete headers['Sdui-Canary-Level']
    return JSON.stringify(data)
  }
}
export default class Authenticator {
  static authenticatorKey = () => '/key'

  static authenticatorKeyItem = (key) => `/key/${key}`

  static authenticatorCode = (uuid) => `/code/${uuid}`

  static authenticatorCodes = () => '/codes'

  static postRegisterCode (payload) {
    return axios.post(this.authenticatorKey(), payload, { ...vaultProxyAxiosConfig, retry: MAX_RETRIES })
  }

  static getCode (uuid) {
    return axios.get(this.authenticatorCode(uuid), { ...vaultProxyAxiosConfig, retry: MAX_RETRIES })
  }

  static postAuthCodes (payload) {
    return axios.post(this.authenticatorCodes(), payload, { ...vaultProxyAxiosConfig, retry: MAX_RETRIES, showMessages: false })
  }

  static deleteCode (key) {
    return axios.delete(this.authenticatorKeyItem(key), vaultProxyAxiosConfig)
  }
}
